import React, {useState, useContext} from 'react';
import * as S from './style';
import * as SS from '../../common/styled-components/styled-components';
import { ValidateOfferCode } from "../../../../app/js/services/parent-api"
import { SemContext } from "../../context/SemContext";
import { setProducts, setCoupons, getCatalogProducts, setShowGradeSelectionPopup, setPromoCodeInContext } from "../../actions/actions";

const InputActivationCode = () => {

  const [invalidPromoCode, setInvalidPromoCode] = useState(false);
  const [promoCode, setPromoCode] = useState('');
  const [showPopup, setShowPopup] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  let { state, dispatch } = useContext(SemContext);
  const { settings } = state;

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    const campaign_code = localStorage.getItem("campaign_code");
    const variant = localStorage.getItem("sem_variant") || state.variant;

    let pc_code = campaign_code == 'undefined' ? 'first_cry' : campaign_code;

    const resp = await ValidateOfferCode({ pc_code, code: promoCode });
    dispatch(setPromoCodeInContext(promoCode));
    if (!resp.valid) {
      setInvalidPromoCode(true);
    } else {
      if (resp.products.length === 0) {
        const params = { grade_code: 'pk', preferred_language: settings.preferred_language, variant: variant};
        dispatch(await getCatalogProducts(params));
      } else {
        dispatch(setProducts(resp.products));
      }
      if (resp.coupons.length !== 0) {
        dispatch(setCoupons(resp.coupons));
      }
      dispatch(setShowGradeSelectionPopup(true));
      setShowPopup(false);
    }
    setIsSubmitted(true);
  }


  return (
    <>
      { showPopup &&
        <SS.ModalOverlay>
          <SS.Modal>
            <SS.ModalTitle>Enter Activation Code</SS.ModalTitle>
            <SS.ModalBody>
              <form onSubmit={(e) => onSubmitHandler(e)}>
                <S.InputWrapper>
                  <S.Input type="text" maxLength="15" spellCheck="false" onChange={(e) => setPromoCode(e.target.value)} submitted={isSubmitted}>
                  </S.Input>
                  <S.SubmitPromoCodeBtn onClick={(e) => onSubmitHandler(e)}>
                    {invalidPromoCode ?
                      `Try Again` : `Apply`
                    }
                  </S.SubmitPromoCodeBtn>
                </S.InputWrapper>
                {invalidPromoCode && 
                  <S.Error>
                    Invalid activation code
                  </S.Error>
                }
              </form>
            </SS.ModalBody>
          </SS.Modal>
        </SS.ModalOverlay>
      }
    </>
  )
}

export default InputActivationCode; 